import { NationalHolidaysInterface } from "../../interface/nationalHolidayInterface";
interface Log {
    date: string;
    duration: number;
}

function getDayOfWeek(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { weekday: "long" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
}

function getWeekNumber() {
    let currentDate: any;
    let firstJan: any;
    currentDate = new Date();
    firstJan = new Date(currentDate.getFullYear(), 0, 1);
    const days = Math.floor((currentDate - firstJan) / (24 * 60 * 60 * 1000));
    const weekNumber = Math.ceil((days + firstJan.getDay() + 1) / 7);

    return weekNumber;
}

function getDateFromWeekAndWeekday(year: number, weekNumber: number, weekdayNumber: number) {
    let januaryFirst = new Date(year, 0, 1);
    let dayOfWeek = januaryFirst.getDay();
    let startOffset = (dayOfWeek > 0 ? dayOfWeek - 1 : 6); // 0-based index of the day of the week (Monday is 0)
    let firstWeekStart = new Date(year, 0, 1 + (7 - startOffset));
    let weekStart = new Date(firstWeekStart.getTime() + (weekNumber - 1) * 7 * 24 * 60 * 60 * 1000);
    let targetDate = new Date(weekStart.getTime() + weekdayNumber * 24 * 60 * 60 * 1000);
    return targetDate;
}

function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function isHoliday(date: Date, nationalHolidays: NationalHolidaysInterface[], weeklyHolidays: string[]) {
    const holidays = Object.values(weeklyHolidays ?? []);
    const nationalHolidaysDates = nationalHolidays?.map(nationalHoliday => nationalHoliday.date);
    if (holidays?.includes(formatDate(date)) || nationalHolidaysDates?.includes(formatDate(date))) {
        return true;
    }
    else {
        return false;
    }
}

export function calculateHoursPerDay(
    currentWeekLogs: Log[],
    selectedWeek: number,
    selectedYear: number,
    nationalHolidays: NationalHolidaysInterface[],
    weeklyHolidays: string[],
) {
    const currentYear = new Date().getFullYear();
    const currenWeek = getWeekNumber();
    if (
        currentYear < selectedYear ||
        (currentYear == selectedYear && currenWeek < selectedWeek)
    ) {
        return {
            message: "Upcoming week",
            color: "status.upcoming.main",
            textColor: "status.upcoming.text",
            circleColor: "status.upcoming.circle",
        };
    }
    const requiredHours = 8;
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
    let validation = true;
    let overtime = false;
    let totalHours = 0;

    for (const day of daysOfWeek) {
        let currentDay = daysOfWeek[new Date().getDay() - 1];
        let prevDay = daysOfWeek[new Date().getDay()];
        let hour = new Date().getHours();

        if (currentDay == day && selectedWeek == currenWeek && hour < 17) {
            break;
        }
        if (prevDay == day && selectedWeek == currenWeek) {
            break;
        }
        let date = getDateFromWeekAndWeekday(selectedYear, selectedWeek -1, daysOfWeek.indexOf(day));

        const logsForDay = currentWeekLogs.filter(
            (log) => getDayOfWeek(log.date) === day
        );

        totalHours = 0;
        for (const log of logsForDay) {
            let duration = log.duration;
            totalHours = totalHours + duration;
        }
        totalHours = totalHours / 60;
        if (!isHoliday(date, nationalHolidays, weeklyHolidays) || totalHours != 0) {
            if (totalHours < requiredHours) {
                validation = false;
            }

            if (totalHours > requiredHours) {
                overtime = true;
            }
        }
    }
    if (overtime) {
        return {
            message: "Overtime.",
            color: "status.overtime.main",
            textColor: "status.overtime.light",
            circleColor: "status.overtime.circle",
        };
    } else if (validation) {
        return {
            message: "All hours entered correctly.",
            color: "status.sufficient.main",
            textColor: "status.sufficient.light",
            circleColor: "status.sufficient.circle",
        };
    } else {
        return {
            message: "Insufficient time logged.",
            color: "status.insufficient.main",
            textColor: "status.insufficient.light",
            circleColor: "status.insufficient.circle",
        };
    }
}
